export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sortable: false,
            filter: false,
            _filter: false,
            fixed: true,
            active: true,
            _style: "width:5%",
        },
        {
            key: "id",
            label: "#",
            sorter: true,
            filter: true,
            _filter: false,
            _style: "width:10%",
            active: true
        },
        {
            key: "name",
            label: "Name",
            sorter: true,
            filter: true,
            _filter: true,
            active: true
        },
        {
            key: "pluginName",
            label: "Plugin Name",
            sorter: true,
            filter: true,
            _filter: true,
            active: true
        },
        {
            key: "created_at",
            label: "Created At",
            sorter: true,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "updated_at",
            label: "Updated At",
            sorter: true,
            filter: false,
            _filter: false,
        }
    ],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    allFields: [],
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}